<div class="main-content" *ngIf="_userRoles != null">
    <div class="container-fluid">
        <div class="card sq-card">
            <div class="card-header card-header-squirrel">
                <div>
                    <h4>{{this.translate.data['PROJECTSMANAGEMENT'] | translate}}</h4>             

                    <!-- <button matTooltip="{{this.translate.data['ADDNEWPROJECT'] | translate}}" mat-raised-button type="submit" class="btn btn-squirrel pull-right" (click)="addProject()"
                                        [hidden]="!(_userRoles.includes('CREATE_PROJECT') || _userRoles.includes('admin'))">
                        <mat-icon>add</mat-icon>
                    </button> -->
                </div>
                <div class="clearfix"></div>
            </div>
            <div class="card-body" *ngIf="_userRoles.includes('MANAGE_PROJECTS') || _userRoles.includes('admin') || _userRoles.includes('TENANTADMIN')">
                <div class="row">
                    <div class="col-md-8">
                        <a>
                            <button mat-raised-button class="btn btn-squirrel pull-left" style="margin-top: 6px;margin-left: 5px" matTooltip="{{this.translate.data['ADDNEWPROJECT'] | translate}}"
                                (click)="addProject()" [hidden]="!(_userRoles.includes('CREATE_PROJECT') || _userRoles.includes('TENANTADMIN') || _userRoles.includes('admin'))">
                                Neues Projekt
                            </button>
                        </a>                   
                        <a *ngIf="isWPTenant && _userRoles.includes('admin')">
                            <button mat-raised-button class="btn btn-squirrel pull-left" style="margin-top: 6px;margin-left: 5px" matTooltip="Winplan-Projekte migrieren"
                                            (click)="migrateWPO2Projects()" >Projekte migrieren</button>
                        </a>                   
                        <a>
                            <button mat-raised-button class="btn btn-squirrel pull-left" style="margin-top: 6px;margin-left: 5px" matTooltip="{{this.translate.data['UPDALLPROJECTS'] | translate}}"
                                            (click)="updateAllProjects()" [hidden]="!(_userRoles.includes('admin'))||(onlyArchived)">{{this.translate.data['UPDALLPROJECTS'] | translate}}</button>
                                            <a *ngIf="isUpdating">Update läuft .....</a>
                        </a>                   
                    </div>
                    <div class="col-md-8">
                        <mat-slide-toggle  [disabled]="false" color="primary" (change)="onChange()">archivierte Projekte</mat-slide-toggle> 
                    </div>
          
                </div>
                <div class="row">
                    <div class="col-md-12 tenant-grouproles-board-body-table">
                        <div class="project-board-body-table" style="overflow: auto;">
                            <div class="example-loading-shade" *ngIf="isLoadingResults || isRateLimitReached">
                            <mat-spinner *ngIf="isLoadingResults"></mat-spinner>
                            <div class="example-rate-limit-reached" *ngIf="isRateLimitReached">
                                Squirrel's API rate limit has been reached. It will be reset in one minute.
                            </div>
                        </div>
                        <ag-grid-angular class="ag-theme-balham" style="width:100%; height: 92%; padding: 5px;"
                            [overlayLoadingTemplate]="overlayLoadingTemplate"
                            [gridOptions]="gridOptions"
                            (gridReady)="onGridReady($event)" 
                            [frameworkComponents]="frameworkComponents"
                            [rowData]="rowData">
                        </ag-grid-angular>                    
                    </div>
                </div>               
            </div>               
        </div>
    </div>
</div>
